module.exports = __webpack_public_path__ + "static/media/shikoku.32751eed.svg";